const GB_DELIVERY_ZONE = 'Asia/Karachi';
const GB_DAY = 24 * 60 * 60 * 1000;

/**
 * @param {number} offsetDays
 */
function gbDeliveryLabel(offsetDays) {
  return new Intl.DateTimeFormat('en', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    timeZone: GB_DELIVERY_ZONE,
  }).format(new Date(Date.now() + offsetDays * GB_DAY));
}

function fillGbDeliveryWindows() {
  const start = gbDeliveryLabel(3);
  const end = gbDeliveryLabel(5);
  document.querySelectorAll('[data-gb-delivery-window]').forEach((node) => {
    if (!(node instanceof HTMLElement)) return;
    const template = node.dataset.template || 'Estimated delivery in Pakistan from __START__ to __END__.';
    const next = template.replace('__START__', start).replace('__END__', end);
    if (node.textContent !== next) node.textContent = next;
  });
}

if (!window.gbDeliveryWindowReady) {
  window.gbDeliveryWindowReady = true;
  const schedule = () => {
    if (window.gbDeliveryWindowFrame) return;
    window.gbDeliveryWindowFrame = requestAnimationFrame(() => {
      window.gbDeliveryWindowFrame = 0;
      fillGbDeliveryWindows();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
  document.addEventListener('cart:update', schedule);
  const root = document.body;
  if (root) {
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches('[data-gb-delivery-window]') || node.querySelector('[data-gb-delivery-window]')) {
            schedule();
            return;
          }
        }
      }
    }).observe(root, { childList: true, subtree: true });
  }
}
